import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { HotelRentalsPage } from './pages/HotelRentalsPage';
import { ReservationPage } from './pages/ReservationPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { BlogsPage } from './pages/BlogsPage';
import { ContactPage } from './pages/ContactPage';
import { ProductReservePage } from './pages/ProductReservePage';
import { CancellationPolicyPage } from './pages/CancellationPolicyPage';
import { FAQPage } from './pages/FAQPage';
import { ProductsPage } from './pages/ProductsPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { PartnersPage } from './pages/PartnersPage';
import { HotspotPage } from './pages/HotspotPage';
export interface RentalFormData {
  rentalType: string;
  placeName: string;
  placeAddress: string;
  deliveryLocation: string;
  equipment: string;
  rentalDate: string;
  returnDate: string;
  weight: string;
  height: string;
}
export interface FullReservationData extends RentalFormData {
  price: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  message: string;
  gelCushion: string;
}
export interface SelectedProduct {
  name: string;
  price: number;
  image: string;
}
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [rentalFormData, setRentalFormData] = useState<RentalFormData | null>(null);
  const [fullReservationData, setFullReservationData] = useState<FullReservationData | null>(null);
  const [selectedProduct, setSelectedProduct] = useState<SelectedProduct | null>(null);
  const navigate = (page: string) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };
  const handleRentalFormSubmit = (data: RentalFormData) => {
    setRentalFormData(data);
    navigate('reserve');
  };
  const handleFullReservationSubmit = (data: FullReservationData) => {
    setFullReservationData(data);
    navigate('cart');
  };
  const handleRentProduct = (product: SelectedProduct) => {
    setSelectedProduct(product);
    navigate('product-reserve');
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onSubmitRentalForm={handleRentalFormSubmit} onRentProduct={handleRentProduct} data-id="element-0" />;
      case 'about':
        return <AboutPage onNavigate={navigate} data-id="element-1" />;
      case 'services':
        return <ServicesPage onNavigate={navigate} data-id="element-2" />;
      case 'hotel-rentals':
        return <HotelRentalsPage onNavigate={navigate} data-id="element-3" />;
      case 'hotspot':
        return <HotspotPage onNavigate={navigate} data-id="element-4" />;
      case 'reserve':
        return <ReservationPage onNavigate={navigate} initialFormData={rentalFormData} onSubmitFullReservation={handleFullReservationSubmit} data-id="element-5" />;
      case 'product-reserve':
        return <ProductReservePage onNavigate={navigate} selectedProduct={selectedProduct} onSubmitRentalForm={handleRentalFormSubmit} data-id="element-6" />;
      case 'cart':
        return <CartPage onNavigate={navigate} reservationData={fullReservationData} data-id="element-7" />;
      case 'checkout':
        return <CheckoutPage onNavigate={navigate} reservationData={fullReservationData} data-id="element-8" />;
      case 'products':
        return <ProductsPage onNavigate={navigate} onRentProduct={handleRentProduct} data-id="element-9" />;
      case 'blogs':
        return <BlogsPage onNavigate={navigate} data-id="element-10" />;
      case 'partners':
        return <PartnersPage onNavigate={navigate} data-id="element-11" />;
      case 'contact':
        return <ContactPage onNavigate={navigate} data-id="element-12" />;
      case 'cancellation-policy':
        return <CancellationPolicyPage onNavigate={navigate} data-id="element-13" />;
      case 'faq':
        return <FAQPage onNavigate={navigate} data-id="element-14" />;
      default:
        if (currentPage.startsWith('blog-post-')) {
          const blogIdx = parseInt(currentPage.replace('blog-post-', ''), 10);
          return <BlogPostPage onNavigate={navigate} blogIndex={blogIdx} data-id="element-15" />;
        }
        return <HomePage onSubmitRentalForm={handleRentalFormSubmit} onRentProduct={handleRentProduct} data-id="element-16" />;
    }
  };
  return <div className="min-h-screen flex flex-col w-full" data-id="element-17">
      <Navbar onNavigate={navigate} currentPage={currentPage} data-id="element-18" />
      {renderPage()}
      <Footer onNavigate={navigate} data-id="element-19" />
    </div>;
}